<template>
  <v-dialog v-model="dialogVisible" max-width="500">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <p>{{ message }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialogVisible = false">Close</v-btn>
        <v-btn
          v-for="(action, index) in actions"
          :key="index"
          color="primary"
          @click="handleAction(action)"
        >
          {{ action.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreditWarningDialog",
  data() {
    return {
      dialogVisible: false,
      title: "",
      message: "",
      actions: []
    };
  },
  created() {
    // Listen for the show-dialog event from the root
    this.$root.$on("show-dialog", this.showDialog);
  },
  beforeDestroy() {
    // Clean up the event listener
    this.$root.$off("show-dialog", this.showDialog);
  },
  methods: {
    showDialog(options) {
      this.title = options.title || "Warning";
      this.message = options.message || "";
      this.actions = options.actions || [];
      this.dialogVisible = true;
    },
    handleAction(action) {
      if (action.handler && typeof action.handler === "function") {
        action.handler();
      }
      this.dialogVisible = false;
    }
  }
};
</script>
